(function () {
  'use strict';

  var SIZE_ALIASES = [
    ['split california king', ['split california king', 'split cal king']],
    ['split king', ['split king']],
    ['california king', ['california king', 'cal king', 'cal. king']],
    ['twin xl', ['twin xl', 'twin extra long', 'twin x long']],
    ['full xl', ['full xl', 'full extra long', 'full x long']],
    ['olympic queen', ['olympic queen']],
    ['queen', ['queen']],
    ['full', ['full', 'double']],
    ['twin', ['twin', 'single']],
    ['king', ['king', 'eastern king']]
  ];

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[®™]/g, '').replace(/[-_/]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function sizeFromValue(value) {
    var normalized = normalize(value);
    for (var i = 0; i < SIZE_ALIASES.length; i += 1) {
      for (var j = 0; j < SIZE_ALIASES[i][1].length; j += 1) {
        var alias = SIZE_ALIASES[i][1][j];
        if (normalized === alias || normalized.indexOf(alias) !== -1) return SIZE_ALIASES[i][0];
      }
    }
    return '';
  }

  function titleCase(value) {
    return String(value || '').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function money(cents) {
    var amount = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.MHMainProductPrice) {
      return window.Shopify.formatMoney(amount, window.MHMainProductPrice.moneyFormat);
    }
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(amount / 100);
    } catch (error) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function parseJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function init(root) {
    if (!root || root.dataset.mhBundleReady === 'true') return;
    root.dataset.mhBundleReady = 'true';

    var mattressData = parseJSON(root.querySelector('[data-mh-mattress-json]'));
    var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-mh-support-card-wrap]'));
    var addButton = root.querySelector('[data-mh-bundle-add]');
    var mattressImage = root.querySelector('[data-mh-bundle-mattress-image]');
    var mattressVariantLabel = root.querySelector('[data-mh-bundle-mattress-variant]');
    var mattressPrice = root.querySelector('[data-mh-bundle-mattress-price]');
    var summaryMattress = root.querySelector('[data-mh-summary-mattress]');
    var summarySupportRow = root.querySelector('[data-mh-summary-support-row]');
    var summarySupportLabel = root.querySelector('[data-mh-summary-support-label]');
    var summarySupport = root.querySelector('[data-mh-summary-support]');
    var summaryTotal = root.querySelector('[data-mh-bundle-total]');
    var totalLabel = root.querySelector('[data-mh-total-label]');
    var emptyState = root.querySelector('[data-mh-support-empty]');
    var emptyTitle = root.querySelector('[data-mh-support-empty-title]');
    var message = root.querySelector('[data-mh-bundle-message]');
    var preselectFirst = root.dataset.preselectFirst === 'true';
    var showCompare = root.dataset.showCompare === 'true';
    var selectedWrap = null;
    var stateVariant = null;

    if (!mattressData || !addButton) return;

    wraps.forEach(function (wrap) {
      wrap._product = parseJSON(wrap.querySelector('[data-mh-support-product-json]'));
      wrap._variant = null;
    });

    function getMainForm() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('.product-container form[action*="/cart/add"]'));
      return forms.find(function (form) {
        return form.querySelector('[name="add"],.add_to_cart,[type="submit"]');
      }) || forms[0] || null;
    }

    function variantFromForm() {
      var form = getMainForm();
      var field = form && form.querySelector('[name="id"]');
      if (!field || !field.value) return null;
      return mattressData.variants.find(function (variant) { return String(variant.id) === String(field.value); }) || null;
    }

    function getMattressVariant() {
      if (stateVariant && stateVariant.id) return stateVariant;
      if (window.MHProductState && typeof window.MHProductState.getActiveVariant === 'function') {
        var active = window.MHProductState.getActiveVariant();
        if (active) return active;
      }
      return variantFromForm() || mattressData.variants.find(function (variant) { return variant.available; }) || mattressData.variants[0] || null;
    }

    function mattressSize(variant) {
      if (!variant) return '';
      var configuredIndex = window.MHBeddingSizeConfig ? Number(window.MHBeddingSizeConfig.optionIndex) : -1;
      if (configuredIndex >= 0 && variant.options && variant.options[configuredIndex] != null) {
        var configured = sizeFromValue(variant.options[configuredIndex]);
        if (configured) return configured;
      }
      var sizeIndex = (mattressData.options || []).findIndex(function (name) { return normalize(name).indexOf('size') !== -1; });
      if (sizeIndex >= 0 && variant.options && variant.options[sizeIndex] != null) {
        var direct = sizeFromValue(variant.options[sizeIndex]);
        if (direct) return direct;
      }
      var options = Array.isArray(variant.options) ? variant.options : [];
      for (var i = 0; i < options.length; i += 1) {
        var found = sizeFromValue(options[i]);
        if (found) return found;
      }
      return sizeFromValue(variant.title);
    }

    function findCompatibleVariant(productData, size) {
      if (!productData || !Array.isArray(productData.variants)) return null;
      var available = productData.variants.filter(function (variant) { return variant.available !== false; });
      if (!available.length) return null;
      if (!size) return available.length === 1 ? available[0] : null;
      return available.find(function (variant) {
        var optionSizes = (variant.options || []).map(sizeFromValue).filter(Boolean);
        return optionSizes.indexOf(size) !== -1 || sizeFromValue(variant.title) === size;
      }) || null;
    }

    function setMessage(text) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.toggle('is-visible', Boolean(text));
    }

    function setSelected(wrap) {
      selectedWrap = wrap && wrap._variant ? wrap : null;
      wraps.forEach(function (item) {
        var pressed = item === selectedWrap;
        var button = item.querySelector('[data-mh-support-card]');
        button.classList.toggle('is-selected', pressed);
        button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      updateSummary();
      emitChange();
    }

    function emitChange() {
      var mattressVariant = getMattressVariant();
      document.dispatchEvent(new CustomEvent('mh:support-bundle-change', {
        detail: {
          hasSupport: Boolean(selectedWrap && selectedWrap._variant),
          mattressVariantId: mattressVariant ? Number(mattressVariant.id) : null,
          supportVariantId: selectedWrap ? Number(selectedWrap._variant.id) : null,
          supportProductId: selectedWrap ? Number(selectedWrap._product.id) : null,
          supportTitle: selectedWrap ? String(selectedWrap._product.title || '') : '',
          quantity: 1
        }
      }));
    }

    function updateSummary() {
      var mattressVariant = getMattressVariant();
      if (!mattressVariant) return;
      var mattressAmount = Number(mattressVariant.price || 0);
      if (mattressPrice) mattressPrice.textContent = money(mattressAmount);
      if (summaryMattress) summaryMattress.textContent = money(mattressAmount);
      if (mattressVariantLabel) mattressVariantLabel.textContent = mattressVariant.title || 'Selected variant';
      if (mattressImage && mattressVariant.image) mattressImage.src = mattressVariant.image;

      if (selectedWrap) {
        var supportAmount = Number(selectedWrap._variant.price || 0);
        if (summarySupportRow) summarySupportRow.hidden = false;
        if (summarySupportLabel) summarySupportLabel.textContent = selectedWrap._product.title || 'Support';
        if (summarySupport) summarySupport.textContent = '+' + money(supportAmount);
        if (summaryTotal) summaryTotal.textContent = money(mattressAmount + supportAmount);
        if (totalLabel) totalLabel.textContent = totalLabel.dataset.bundleTotalLabel || 'Bundle total';
        addButton.textContent = addButton.dataset.bundleLabel || 'Add Complete Setup to Cart';
      } else {
        if (summarySupportRow) summarySupportRow.hidden = true;
        if (summarySupport) summarySupport.textContent = '—';
        if (summaryTotal) summaryTotal.textContent = money(mattressAmount);
        if (totalLabel) totalLabel.textContent = totalLabel.dataset.mattressTotalLabel || 'Mattress total';
        addButton.textContent = addButton.dataset.mattressLabel || 'Add Mattress to Cart';
      }
      addButton.disabled = mattressVariant.available === false;
    }

    function syncChoices() {
      var mattressVariant = getMattressVariant();
      if (!mattressVariant) return;
      var size = mattressSize(mattressVariant);
      var previousId = selectedWrap ? selectedWrap.dataset.productId : null;
      var firstCompatible = null;
      var restored = null;
      var compatibleCount = 0;

      wraps.forEach(function (wrap) {
        var button = wrap.querySelector('[data-mh-support-card]');
        var label = wrap.querySelector('[data-mh-support-variant-label]');
        var availability = wrap.querySelector('[data-mh-support-availability]');
        var price = wrap.querySelector('[data-mh-support-price]');
        var compare = wrap.querySelector('[data-mh-support-compare]');
        var compatible = findCompatibleVariant(wrap._product, size);
        wrap._variant = compatible;
        wrap.hidden = !compatible;

        if (!compatible) return;
        compatibleCount += 1;
        button.disabled = false;
        label.textContent = compatible.title === 'Default Title' ? (size ? titleCase(size) : 'Compatible option') : compatible.title;
        availability.textContent = size ? 'Matched to your ' + titleCase(size) + ' mattress.' : 'Compatible support option.';
        price.textContent = '+' + money(compatible.price);
        var hasCompare = showCompare && Number(compatible.compareAtPrice) > Number(compatible.price);
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(compatible.compareAtPrice) : '';
        if (!firstCompatible) firstCompatible = wrap;
        if (previousId && String(wrap.dataset.productId) === String(previousId)) restored = wrap;
      });

      if (emptyState) emptyState.hidden = compatibleCount > 0;
      if (emptyTitle && compatibleCount === 0) {
        emptyTitle.textContent = size ? 'No compatible support is currently available in ' + titleCase(size) + '.' : 'Choose a mattress size to see compatible support.';
      }

      if (restored && restored._variant) setSelected(restored);
      else if (preselectFirst && firstCompatible) setSelected(firstCompatible);
      else setSelected(null);
      setMessage('');
    }

    wraps.forEach(function (wrap) {
      var button = wrap.querySelector('[data-mh-support-card]');
      button.addEventListener('click', function () { setSelected(selectedWrap === wrap ? null : wrap); });
    });

    addButton.addEventListener('click', function () {
      var mattressVariant = getMattressVariant();
      if (!mattressVariant || mattressVariant.available === false) return;
      var form = getMainForm();
      var quantityField = form && form.querySelector('input[name="quantity"]');
      var quantity = quantityField && Number(quantityField.value) > 0 ? Number(quantityField.value) : 1;
      var items = [{ id: Number(mattressVariant.id), quantity: quantity }];
      if (selectedWrap) items.push({ id: Number(selectedWrap._variant.id), quantity: quantity });
      var originalLabel = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adding to cart…';
      setMessage('');

      fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'The selection could not be added.');
          window.location.href = root.dataset.cartUrl;
        });
      }).catch(function (error) {
        addButton.disabled = false;
        addButton.textContent = originalLabel;
        setMessage(error.message || 'The selection could not be added. Please try again.');
      });
    });

    document.addEventListener('mh:product-state-change', function (event) {
      stateVariant = event && event.detail ? event.detail.variant : null;
      window.requestAnimationFrame(syncChoices);
    });
    syncChoices();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mh-support-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
